import { Box, BoxProps } from '@amzn/awsui-components-core';
import { ContentRequest, UserProfile } from '@amzn/awscat-pattern-library-service-model';
import React from 'react';
import { IMplServiceClient } from '../../api/IMplServiceClient';
import { MplServiceClientFactory } from '../../api/MplServiceClientFactory';
import constants from '../../common/constants';
import { WorkflowTableIdentity } from '../../common/CookieRegistry';
import {
  ContentSuggestionDeleteCol,
  DefaultContentRequestTableColumns,
} from '../content-requests/ContentRequestColumnDefinition';
import ContentRequestTable from '../content-requests/ContentRequestTable';

interface ContentRequestsTableProps {
  wrapperPadding?: BoxProps.Spacing;
  userProfile: UserProfile;
}

interface ContentRequestsTableState {
  isLoading: boolean;
  contentRequests: ContentRequest[];
}

class ContentRequestsTable extends React.Component<
  ContentRequestsTableProps,
  ContentRequestsTableState
> {
  private mplServiceClient: IMplServiceClient;
  private contentRequestTableColumns;

  // @ts-expect-error TS7006 - strict migration
  constructor(props) {
    super(props);
    this.mplServiceClient = MplServiceClientFactory.create();
    this.contentRequestTableColumns = DefaultContentRequestTableColumns.concat(
      ContentSuggestionDeleteCol,
    );

    this.state = {
      contentRequests: [],
      isLoading: true,
    };
  }

  public async componentDidMount() {
    this.loadData();
  }

  public render() {
    const { wrapperPadding } = this.props;
    const { isLoading, contentRequests } = this.state;

    const contentRequestsTable = (
      <Box padding={wrapperPadding}>
        <ContentRequestTable
          headerText={constants.CONTENT_REQUESTS_TABLE_HEADER}
          tableId={WorkflowTableIdentity.ContentRequestsTable}
          contentRequests={contentRequests}
          columnDefinitions={this.contentRequestTableColumns}
          loading={isLoading}
          onRefreshClick={this.loadData}
        />
      </Box>
    );

    return contentRequestsTable;
  }

  private loadData = async () => {
    this.setState({
      isLoading: true,
    });

    const { userProfile } = this.props;
    const { userId } = userProfile;
    const { contentRequests } =
      await this.mplServiceClient.listContentRequestsForAuthenticatedUser(userId);

    this.setState({
      contentRequests,
      isLoading: false,
    });
  };
}

export default ContentRequestsTable;
